
/**
 * Validate Dom fields
 * Next sibbling element must be a <div class="invalid-feedback"></div>
 * Validate form fields
 * @param [string] fieldIds 
 */
export const FieldValidation = (fieldIds) => {
  let frmValid = true;
  let frmData = {};
  fieldIds.map((id) => {
    const el = document.getElementById(id);
    if (el) {
      el.classList.remove('is-invalid');
      if (!el.checkValidity()) {
        el.classList.add('is-invalid');
        el.nextSibling && el.nextSibling.classList.replace('valid-feedback', 'invalid-feedback');
        frmValid = false;
      }
      else {
        el.classList.replace('is-invalid', 'is-valid');
        el.nextSibling && el.nextSibling.classList.replace('invalid-feedback', 'valid-feedback');
        frmData[el.name] = el.value;
      }
    }
  });
  return { result: frmValid, "data": frmData };
};


/**
 * Format file size
 * @param int value 
 * @returns 
 */
export const FormatFileSize = (value) => {
  return '2M';
}


/**
 * Check if a date time older than how many hours
 * @param string past - date string 
 * @param int hours 
 * @return bool
 */
export const OlderThan = (past, hours) => {
  let old = new Date(past);
  let cur = new Date();
  return (old.getTime() + (hours * 60 * 60 * 1000)) < cur.getTime();
}

// Fade the preview in 4 seconds
export const fadeOut = (elId) => {
  const el = document.getElementById(elId);
  el.style.opacity = 0.2;
  el.style.transition = "opacity 3s";
};
  
  // Show the preview in 2 seconds
export const fadeIn = (elId) => {
  const el = document.getElementById(elId);
  el.style.opacity = 1;
  el.style.transition = "opacity 2s";
}

/**
 * Converting address object to address line - E.g
 * Michael Bonilla
 * 3510 Falls Branch Ct
 * Buford, GA 30519
 * @param {} address - { name:, line1:, ... }
 */
export function ImplodeAddressLines({ address }) {
  if (address) {
    return (
      <>
        <div>{address.company}</div>
        <div>{address.name}</div>
        <div>{address.line1}</div>
        <div>{address.city}, {address.state} {address.zip_code}</div>
        <div>{address.phone}</div>
      </>
    );
  }
}

/**
 * convert line break to list of string
 * @param {*} str 
 */
export function nl2br(str) {
  if (str) {    
    const arr = str.split("\n");
    return ( arr.join("<br />") );
  }
  return null;
}

export function money(amount) {
  return parseFloat(amount).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
}

export function toInt(value) {
  return value ? parseInt(value) : 0;
}

/**
 * Check if a value is empty
 * @param obj 
 * @returns boolean for empty
 */
export function isEmpty(value) {
  let ok = (value == null);
  return ok ? ok : (typeof value === 'string' && (value.trim().length === 0 || Number(value) == 0));
}

// Function to read a file and return a Data URL
export function readFileAsDataURL(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    // Event listener for when the file is successfully read
    reader.onload = () => {
      resolve(reader.result);
    };

    // Event listener for errors during the file reading process
    reader.onerror = () => {
      reject(new Error("Error reading file"));
    };

    // Read the file as a Data URL
    reader.readAsDataURL(file);
  });
}
